module.exports = __webpack_public_path__ + "1c2ba0e4ccacd033af703221aaf2e1ab.jpg";